import { useLocalizable } from '@contexts/LocalizableContext'
import { LangSelector } from './LangSelector'

/**
 * Language selector rendered in the SBRM drawer/modal header slot.
 * Renders nothing unless the open form actually exposes localizable fields.
 */
export const HeaderLangSelector = () => {
  const localizable = useLocalizable()

  if (!localizable?.hasLocalizableFields) {
    return null
  }

  return <LangSelector type="segment" segmentedProps={{ block: false }} />
}
